import emailJsBrowser from '@emailjs/browser';

/**
 * All enviorements display log.
 */
export function commonDisplayLog(...value) {
    console.log(value);
}
/**
 * Enviorements display log.
 * development and test environments
 */
export function withoutProductionDisplayLog(...value) {
    if (process.env.REACT_APP_PROJECT_ENV !== 'production') {
        console.log(value);
    }
}
/**
 * Parameterize enviorements display log.
 * development,production and test environments
 */
export function envSpecificDisplayLog(env, ...value) {
    if (env === process.env.REACT_APP_PROJECT_ENV) {
        console.log(value);
    }
}

/**
 * Send email using emailjs.
 */
export async function sendCustomEmail(formdata) {
    const templateParams = {
        from_name: formdata.name,
        message: formdata.message,
        companyName: formdata.companyName,
        to_name: 'CSWAP Systems',
        email: formdata.email,
        isAgree: formdata.isAgree
    };
    return await emailJsBrowser.send(process.env.REACT_APP_SERVICE_API, process.env.REACT_APP_TEMPLATE_ID, templateParams, process.env.REACT_APP_PUBLIC_KEY)
        .then((result) => {
            withoutProductionDisplayLog(result.text);
            return result.text;
        }, (error) => {
            return withoutProductionDisplayLog(error.text);
        });
}

export const scrollToSection = (event, sectionID) => {
  if (event) event.preventDefault();

  const targetElement = document.getElementById(sectionID);

  if (!targetElement) return;

  const navbarHeight = 88;

  window.scrollTo({
    top: targetElement.offsetTop - navbarHeight,
    behavior: 'smooth'
  });
};

export const redirectToExternalURL = (url) => {
  window.open(url, "_blank");
};
